module.exports = __webpack_public_path__ + "static/practice2-c224fd43f18f2e123a5520bde4d480f7.png";